import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','tglD1', 'tglD2','itemno', 'itemname', 'itemcategory', 'customer_id', 'CustName', 'customer_group'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerretur${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                obj.ttlRetur = meta.ttlRetur;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    assignment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'assignmentname', 'employee_name'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerretur/assignmentlist${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    saveassignment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('/bakerycustomerretur/saveassignment', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },

    removeassignment(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/bakerycustomerretur/removeassignment/${obj.assignmentkey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    exportassignmentxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2', 'assignmentname'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                axios({
                    url: `/bakerycustomerretur/exportassignmentxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'assignment_retur_list.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
    
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    delivery(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [ 'tgl1', 'tgl2','customer_id', 'CustName'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bakerycustomerretur/delivery${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },    
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post('/bakerycustomerretur', obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.delete(`/bakerycustomerretur/${obj.tablekey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        })
    },

    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2','tglD1', 'tglD2','itemno', 'itemname', 'itemcategory', 'customer_id', 'CustName', 'customer_group'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/bakerycustomerretur/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Customer_retur_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};